import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAppScopeStore } from '@frontend/scope';
import {
  useMessagingAIRCustomizationFlag,
  useVoiceAIRCustomizationFlag,
  useAIRIntegrationCustomizationFlag,
} from '@frontend/shared';
import { useOnlineSchedulingDirectBookingAccess } from './use-online-scheduling-direct-booking-access';

export const useGetReschedulingRulesAccess = (locationIds?: string[]) => {
  const { selectedLocationIds } = useAppScopeStore();

  const cfLocationIds = locationIds?.length ? locationIds : selectedLocationIds;

  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { isOnlineSchedulingDirectBookingEnabled } = useOnlineSchedulingDirectBookingAccess();

  const [isReschedulingRulesEnabled, isLoadingRulesWetag] = ScheduleOrg.useWetag('rescheduling-rules');

  // 'online-scheduling-direct-booking' wetag is required for non-AIR users to have rescheduling rules access. However, rescheduling rules isn't included in the initial scope so still needs it's own wetag.
  const hasDirectBookingAccess = isOnlineSchedulingDirectBookingEnabled && isReschedulingRulesEnabled;

  const { hasWeaveAIRIntegrationAccess } = useAIRIntegrationCustomizationFlag(cfLocationIds);

  const { weaveVoiceAIActive } = useVoiceAIRCustomizationFlag(cfLocationIds);

  const { weaveMessagingAIActive } = useMessagingAIRCustomizationFlag(cfLocationIds);

  const hasWeaveAiReceptionistAccess = hasWeaveAIRIntegrationAccess && (weaveVoiceAIActive || weaveMessagingAIActive);

  const isLoading = isLoadingV3Flag || isLoadingRulesWetag;

  const access = isScheduleV3FlagEnabled && (hasWeaveAiReceptionistAccess || hasDirectBookingAccess);

  const hasReschedulingRulesAccess = isLoading ? false : access;

  return {
    isLoading,
    hasReschedulingRulesAccess,
  };
};
